import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { reactiveOmit } from '@vueuse/core';
    import {
        TooltipArrow,
        TooltipContent,
        type TooltipContentEmits,
        type TooltipContentProps,
        TooltipPortal,
        useForwardPropsEmits,
    } from 'reka-ui';

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'TooltipContent',
  props: {
    forceMount: { type: Boolean },
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: {},
    sideOffset: { default: 4 },
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    positionStrategy: {},
    updatePositionStrategy: {},
    class: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(__props: any, { emit: __emit }) {

    

    const props = __props;

    const emits = __emit;

    const delegatedProps = reactiveOmit(props, 'class');
    const forwarded = useForwardPropsEmits(delegatedProps, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TooltipPortal), null, {
    default: _withCtx(() => [
      _createVNode(_unref(TooltipContent), _mergeProps({ "data-slot": "tooltip-content" }, { ..._unref(forwarded), ..._ctx.$attrs }, {
        class: 
                _unref(cn)(
                    'bg-secondary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit rounded-md px-3 py-1.5 text-xs text-balance',
                    props.class,
                )
            
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(_unref(TooltipArrow), { class: "bg-secondary fill-secondary z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })
        ]),
        _: 3
      }, 16, ["class"])
    ]),
    _: 3
  }))
}
}

})